import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';
import { useAtomValue } from 'jotai';
import { applicationStateAtom } from '../../jotaiStore';
import submitFeedback from '../../app/actions/submitFeedback';

const FeedbackModal = ({ handleClose, user }) => {
  const [email, setEmail] = useState('');
  const [feedbackText, setFeedbackText] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const applicationState = useAtomValue(applicationStateAtom);

  const feedbackRef = React.useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await submitFeedback(
        feedbackText,
        email,
        user,
        applicationState,
      );
      // setShowFeedbackModal(false);
      toast.success('Feedback Submitted!', {
        toastId: 'Feedback Submitted',
        theme: 'dark',
      });
      handleClose();
    } catch (error) {
      toast.error('Error submitting feedback: Please try again later', {
        toastId: 'Error submitting feedback',
        theme: 'dark',
      });
      setIsLoading(false);
    }
  };

  // const handleEmailChange = (e) => {
  //   setEmail(e.target.value);
  //   setIsEmailValid(true);
  // };

  // const validateEmail = () => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   setIsEmailValid(emailRegex.test(email));
  // };

  return (
    <motion.div
      className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-[100]"
      onClick={handleClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {isLoading && (
        <div
          className="w-full h-full bg-black/60 flex flex-col justify-center z-[101] content-center items-center"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className="z-[102] animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-colors-green"></div>
          <p className="text-xl mt-5 pl-2 text-colors-green z-[102]">
            Loading...
          </p>
        </div>
      )}
      <div
        className="absolute max-w-2xl w-full bg-shades-base p-8 rounded shadow-lg z-[100]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="absolute top-0 right-0 mt-4 mr-4 rounded-md bg-shades-base focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          onClick={handleClose}
        >
          <span className="absolute -inset-2.5" />
          <span className="sr-only">Close panel</span>
          <XMarkIcon className="w-6 h-6" aria-hidden="true" />
        </button>
        <h2 className="text-2xl font-bold text-colors-green">
          Feedback / Report Issue
        </h2>
        <form>
          <label
            htmlFor="email"
            className="block mt-0 mb-6 text-sm font-medium leading-4 text-shades-text/60"
          >
            Tell us how we can make the app better:
          </label>
          <div className="relative w-full mt-4 mb-2 rounded-md shadow-sm">
            <textarea
              rows={5}
              name="comment"
              id="comment"
              className="block w-full rounded-md border-0 py-1.5 text-shades-baseDark shadow-sm ring-0 ring-slate-100 placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6 bg-shades-text/30 focus:ring-0 or focus:ring-transparent"
              // defaultValue={''}
              // placeholder="The more brutal the better - we can take it!"
              onChange={(e) => {
                setFeedbackText(e.target.value);
              }}
              ref={feedbackRef}
              value={feedbackText}
            />
          </div>
          {/* <p className="mb-4 text-sm text-slate-500">
            The more brutal the better - we can take it!
          </p> */}

          {/* {!user && (
            <>
              <label
                htmlFor="email"
                className="block mt-6 text-sm font-medium leading-6 text-slate-500"
              >
                Email (Optional):
              </label>
              <div className="relative w-full mt-1 rounded-md shadow-sm">
                <input
                  type="email"
                  name="email"
                  id="email"
                  className={`block w-full placeholder-slate-400 rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset bg-slate-500 ${
                    isEmailValid
                      ? 'ring-black-300 text-black  focus:ring-black-500'
                      : 'ring-red-500 text-red-900'
                  }  focus:ring-2 focus:ring-inset ${
                    isEmailValid
                      ? 'focus:ring-black-500'
                      : 'focus:ring-red-500 focus:ring-offset-2'
                  } sm:text-sm sm:leading-6`}
                  style={{
                    '::placeholder': {
                      color: '#64748b',
                    },
                  }}
                  placeholder="you@example.com"
                  aria-invalid={!isEmailValid}
                  aria-describedby="email-error"
                  onChange={handleEmailChange}
                  onBlur={validateEmail}
                />
                {!isEmailValid && (
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ExclamationCircleIcon
                      className="w-5 h-5 text-red-500"
                      aria-hidden="true"
                    />
                  </div>
                )}
              </div>
              {!isEmailValid && (
                <p className="mt-2 text-sm text-red-600" id="email-error">
                  Not a valid email address.
                </p>
              )}
            </>
          )} */}
          <div className="flex justify-end mt-4">
            <button
              type="button"
              className="px-4 py-2 mt-4 mr-4 text-sm font-medium rounded bg-shades-text/30 text-shades-baseDark hover:brightness-90"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              type="button"
              className="px-4 py-2 mt-4 font-bold rounded bg-colors-green text-shades-baseDark hover:brightness-90"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </motion.div>
  );
};

export default FeedbackModal;
